module.exports = __webpack_public_path__ + "assets/img/code.443862a9.png";